function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7051 21.0373V39.8457C10.7051 40.9502 11.6005 41.8457 12.7051 41.8457H32.9668C34.0714 41.8457 34.9668 40.9502 34.9668 39.8457V21.0373L22.8345 10.0017L10.7051 21.0373ZM21.5624 35.4625H16.5837V30.062H21.5624V35.4625ZM21.5624 27.3031H16.5837V21.9027H21.5624V27.3031ZM24.1051 21.9011H29.0853V27.3016H24.1051V21.9011ZM24.1051 30.0589H29.0853V35.4625H24.1051V30.0589Z",
  fill: "#943FA1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.663 21.1643L24.4688 4.6109C23.5241 3.75177 22.1453 3.75177 21.1992 4.6109L3.00651 21.1643C1.93202 22.1424 1.78924 23.8841 2.69065 25.0515C3.194 25.7025 3.91513 26.0374 4.64347 26.0374C5.21894 26.0374 5.79873 25.8261 6.27467 25.3926L22.8347 10.3259L39.3963 25.3926C40.4765 26.377 42.076 26.2173 42.9774 25.0515C43.8803 23.8841 43.7389 22.1424 42.663 21.1643Z",
  fill: "#943FA1"
});

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.1babcbd2.svg";
export { ForwardRef as ReactComponent };